import { Hashtag } from './Hashtag';
import './Ansprechpartner.css';

export default function Ansprechpartner() {
    return (
        <div className="ansprechpartner-container">
            <h2 className="ansprechpartner-title"><Hashtag text="#Ansprechpartner" /></h2>
            
            <div className="ansprechpartner-content">
                <div className="ansprechpartner-section">
                    <h3 className="ansprechpartner-section-title"><Hashtag text="#Jugend.Fußball" /></h3>
                    <div className="ansprechpartner-item">
                        <strong>Jugendleiter:</strong>
                        <span>Matteo Foschi</span>
                    </div>
                    <div className="ansprechpartner-item">
                        <strong>Email:</strong>
                        <a href="mailto:jugend@djkdurlach.de">jugend@djkdurlach.de</a>
                    </div>
                    <div className="ansprechpartner-item">
                        <strong>Tel:</strong>
                        <a href="tel:017695452012">0176-95452012</a>
                    </div>
                </div>

                <div className="ansprechpartner-section">
                    <h3 className="ansprechpartner-section-title"><Hashtag text="#Herren.Fußball" /></h3>
                    <div className="ansprechpartner-item">
                        <strong>Spielausschuss:</strong>
                        <span>Matteo Foschi</span>
                    </div>
                    <div className="ansprechpartner-item">
                        <strong>Email:</strong>
                        <a href="mailto:mail@djkdurlach.de">mail@djkdurlach.de</a>
                    </div>
                    <div className="ansprechpartner-item">
                        <strong>Tel:</strong>
                        <span>Auf Anfrage</span>
                    </div>
                </div>
                <div className="ansprechpartner-section">
                    <h3 className="ansprechpartner-section-title"><Hashtag text="#DJK.Tennis" /></h3>
                    <div className="ansprechpartner-item">
                        <strong>Leitung Tennis:</strong>
                        <span>Dietmar Sokob</span>
                    </div>
                    <div className="ansprechpartner-item">
                        <strong>Email:</strong>
                    </div>
                    <div className="ansprechpartner-item">
                        <strong>Tel:</strong>
                        <span>Auf Anfrage</span>
                    </div>
                </div>
            </div>
        </div>
    );
}